// store.js
import { configureStore } from '@reduxjs/toolkit';
import createRootReducer from './globalState';

// Function to configure the Redux store
export default function configureAppStore(initialState) {
  const store = configureStore({
    reducer: createRootReducer,
    preloadedState: initialState,
    devTools: process.env.NODE_ENV !== 'production',
  });

  return store;
}
